import { ReactElement } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

import { I18nProvider } from 'providers/I18nProvider';

import store from 'app/store';

import 'assets/styles/Main.scss';

import App from './App';

const container = document.getElementById('root');
if (!container) throw new Error('Failed to find the root element');

const root = createRoot(container);

const Main = (): ReactElement => (
  <Provider store={store}>
    <I18nProvider>
      <App />
    </I18nProvider>
  </Provider>
);

root.render(<Main />);
